import prop from 'ramda/src/prop'
import tryCatch from 'ramda/src/tryCatch'
import always from 'ramda/src/always'
import querySelector from 'root/src/client/logic/route/selectors/querySelector'
import { pipeNotNil } from 'root/src/shared/util/ramdaPlus'

// eslint-disable-next-line import/prefer-default-export
export default state => tryCatch(pipeNotNil(
	querySelector,
	prop('key'),
	x => (global.window ? atob(x) : Buffer.from(x, 'base64').toString()),
	x => JSON.parse(x),
), always(undefined))(state) || {}
